export const ALERT_FILTER_TYPES = {
    frequency: {
        heading: 'Frequency',
        options: [
            { value: 'daily', label: 'Daily' },
            { value: 'weekly', label: 'Weekly' },
            { value: 'monthly', label: 'Monthly' },
        ],
        default: { value: 'daily', label: 'Daily' },
    },
    compare: {
        heading: 'Compare',
        options: [
            { value: 'retailers', label: 'Retailers' },
            { value: 'storetypes', label: 'Store Types' },
            { value: 'storeregions', label: 'Store Regions' },
            { value: 'stores', label: 'Stores' },
            { value: 'brands', label: 'Brands' },
            { value: 'skus', label: "SKU's" },
            { value: 'alerttype', label: 'Alert Types' },
        ],
        default: { value: 'retailers', label: 'Retailers' },
    },
    view: {
        heading: 'Graph Type',
        options: [
            { value: 'lines', label: 'Lines' },
            { value: 'stacked', label: 'Stacked Areas' },
        ],
        default: { value: 'lines', label: 'Lines' },
    },
};
